import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var LogoutIcon = function LogoutIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "LogoutIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.506 4.33a.824.824 0 0 1 1.165 0l3.088 3.088a.824.824 0 0 1 0 1.164l-3.088 3.089a.824.824 0 0 1-1.165-1.165l1.682-1.682H5.941a.824.824 0 1 1 0-1.648h6.247l-1.682-1.682a.824.824 0 0 1 0-1.165",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1 3.882A2.88 2.88 0 0 1 3.882 1h3.089a.824.824 0 0 1 0 1.647H3.882c-.682 0-1.235.553-1.235 1.235v8.236c0 .682.553 1.235 1.235 1.235h3.089a.824.824 0 0 1 0 1.647H3.882A2.88 2.88 0 0 1 1 12.118z",
      clipRule: "evenodd"
    })]
  }));
};

export { LogoutIcon };
